import type { TourDefinition } from '@renderer/hooks/useTour';

export const tourDashboardMesero: TourDefinition = {
  id: 'dashboard-mesero',
  title: 'Cómo usar tu Dashboard',
  steps: [
    {
      element: '[data-tour="dm-ctas"]',
      popover: {
        title: '1. Acciones principales',
        description:
          '"Nuevo pedido" abre el POS directamente para comer aquí. "Mesas del salón" muestra el estado de todas las mesas. Empieza aquí cada mesa que atiendas.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="dm-atencion"]',
      popover: {
        title: '2. Atención requerida',
        description:
          'Aparece cuando cocina terminó algún pedido tuyo (listo para servir) o cuando un cliente pidió la cuenta. Toca el aviso para ir al pedido.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="dm-mesas"]',
      popover: {
        title: '3. Mis mesas activas',
        description:
          'Tus mesas con pedido abierto en este turno. El badge muestra el estado y el tiempo transcurrido. Toca una tarjeta para ver el pedido.',
        side: 'top',
      },
    },
  ],
};
